module.exports = __webpack_public_path__ + "img/chev_left.a04de65c.svg";